import { TranslatePipe } from '../../filters/translate.pipe';
import { LoaderOverlayComponent } from '../../components/loader-overlay/loader-overlay.component';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import Session from '../../utils/session.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
	standalone: true,
	selector: 'modal-insurance-attention',
	templateUrl: './modal-insurance-attention.component.html',
	imports: [ CommonModule, TranslatePipe, LoaderOverlayComponent, FormsModule ]
})
export class ModalInsuranceAttentionComponent implements OnInit {
	private session: Session = inject(Session);
	private dialogRef = inject(MatDialogRef<ModalInsuranceAttentionComponent>);
	private data = inject(MAT_DIALOG_DATA);
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		Object.keys(this.data).forEach(key => this.vm[key] = this.data[key]);
		
		this.vm.incompletePolicy = this.vm.incompletePolicy;
		this.vm.submit = this.submit;
		this.vm.close = this.close;
		
		this.initialize();
	}
	
	initialize() {
		this.vm.user = this.session.getSession().user;
		this.vm.uid = 'pe-' + Date.now();
		this.vm.initialized = true;
	}
	
	submit() {
		this.dialogRef.close(this.vm.incompletePolicy);
	}
	
	close() {
		this.dialogRef.close();
	}
	
}